const headers = {
  name: "Products",
  navigate: {
    tabs: [
      {
        name: "Products",
        path: "/app/products",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
